<template>
  <div class="statements">
    <div class="w3-row-padding" style="padding-left: 0px; padding-right:0px">
      <div class="w3-col m12" style="padding-left: 0px; padding-right:0px">
        <div class="w3-card w3-round w3-white">
          <div class="w3-container w3-padding">
            <h6 v-if="!isAuthenticated" style="text-align:center">
              <login-button v-bind:text="'Login to participate'" />
            </h6>
            <div v-else>
              <h6 class="w3-opacity" style="text-align:center">Create a new Statement</h6>
              <div class="w3-left-align">
                <textarea-autosize name="statement" v-focus="inputFocused" @focus.native="focus()" @blur.native="blur()" rows="3" placeholder="STATEMENT" v-model="statementForm.text" class="w3-margin-bottom form-control"></textarea-autosize>
                <!--
                <rich-text v-bind:content="'statementForm.text'" />
                -->
                <br/>

                <input @keyup.enter="addFormReference()" type="text" name="urlReference" placeholder="SOURCE URL" v-model="statementForm.referenceUrl" class="w3-left w3-margin-right" style="width: 100%; margin-bottom: 5px">
                <br />
                <!--               
                <textarea-autosize @keyup.enter="addFormReference()" name="urlDesc" rows="1" placeholder="SOURCE DESCRIPTION" v-model="statementForm.referenceDesc" class="w3-margin-bottom form-control"></textarea-autosize>
                -->
                <input @keyup.enter="addFormReference()" type="text" name="urlDesc" placeholder="SOURCE DESCRIPTION" v-model="statementForm.referenceDesc" class="w3-margin-bottom" style="width: 100%">
                <br />
                <div v-for="(reference, index) in statementForm.references" class="w3-medium"> 
                  <span v-if="reference.url" class="w3-left">{{reference.url}} &nbsp; </span>
                  <span v-if="reference.description" class="w3-left">{{reference.description}} &nbsp; </span>
                  <button @click="removeFormReference(index)" type="button" class="w3-button w3-text-theme" style="padding:0"><i class="far fa-times-circle"></i></button> 
                </div>
                <br />
                
                <input @keyup.enter="addFormTag()" type="text" name="tags" placeholder="TAG" v-model="statementForm.tag" class="w3-margin-bottom">
                <span v-for="(tag) in statementForm.tags" class="w3-tag w3-medium w3-theme-d5 w3-margin-right w3-margin-bottom"> 
                  {{tag}} &nbsp;<a @click="removeFormTag(tag)" type="button" class="w3-theme-d5"> X</a>
                </span>
              </div>
              <div>
                <save-button @save="addStatement()" v-bind:type="'fal'" v-bind:icon="'comment-alt-check'"/>
                &nbsp;
                <clear-button @clear="resetForm()"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loading-indicator v-if="isLoading" v-bind:fullPage="false" />

    <div v-else>
      <div class="w3-container w3-white w3-round w3-hide-small" style="margin-top: 20px; padding-bottom: 20px" v-for="(statement) in statements"><br>
        <statement-view v-bind:statement="statement" v-bind:buttonType="buttonType" />
      </div>
      
      <div class="w3-hide-medium w3-hide-large" v-for="(statement) in statements"><br>
        <statement-view v-bind:statement="statement" v-bind:buttonType="buttonType" />
      </div>
    </div>
  </div>
</template>

<script>
  import Statements from './Statements.ts'

  export default Statements
</script>
